import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ITasks, ITasksState } from './types/Tasks-interface'

const tasksListState = (state: RootState): ITasksState => state.tasksList

export const TasksList = createSelector(
    [tasksListState],
    (state): ITasks[] => state.Tasks,
)
export const TasksCount = createSelector(
    [tasksListState],
    (state): number => state.TaskCount,
)
export const LoadingTasks = createSelector(
    [tasksListState],
    (state): boolean => state.isLoadingTasks,
)
export const ErrorTasks = createSelector(
    [tasksListState],
    (state): string[] => state.errorTasks,
)

export const LastFetchTasks = createSelector(
    [tasksListState],
    (state): null | number => state.lastFetchTime,
)
export const ContractsIDTasks = createSelector(
    [tasksListState],
    (state): string[] | [] => state.contractsID,
)

export const CurrentPageTasks = createSelector(
    [tasksListState],
    (state): number => state.currentPage,
)

export const CurrentPageTasksInCase = createSelector(
    [tasksListState],
    (state): number => state.currentPageInCase,
)